<template>
  <div style="display: flex; flex-direction: column">
    <div>
      <el-button
        v-show="!disabled"
        size="mini"
        type="primary"
        style="float: right; margin-bottom: 5px"
        @click="addAirline"
      >
        {{ $t("SystemMaintenance.Add") }}
      </el-button>
    </div>
    <cargo-ag-grid
      :grid-options="gridOptions"
      :column-defs="columnDefs"
      :row-data="rowData"
      :show-side-bar="false"
      style="width: 100%; height: 200px"
    />
  </div>
</template>

<script>
import CargoAgGridAdvanceSelectEditor from '@/components/Cargo/Common/CargoAgGridAdvanceSelectEditor/index'
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'

export default {
  name: 'AeVesselMultiJourneyAirline',
  props: {
    job: { type: Object, default: () => { } },
    disabled: { type: Boolean, default: false }
  },
  data() {
    return {
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        singleClickEdit: true,
        frameworkComponents: {
          CargoAgGridAdvanceSelectEditor
        },
        defaultColDef: {
          menuTabs: [], // 去掉每列的菜单
          filter: false
        },
        context: {
          componentParent: this
        }
      },
      rowData: []
    }
  },
  computed: {
    columnDefs() {
      return [
        {
          headerName: this.$t('SeaExport.NumberPasses'),
          colId: 'index',
          field: 'index',
          width: 100
        },
        {
          headerName: this.$t('SeaExport.AirlineCompany'),
          width: 190,
          field: 'airlineCompany',
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'chineseName')
          },
          editable: () => !this.disabled,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: {
            selectProps: {
              selectType: TYPE_NAMES.basic_data_Company,
              tagValue: 'cmpIdx',
              tagName: 'chineseName',
              style: 'width: 100%',
              methodParams: { active: true },
              dataFilterFunction: (item, inputVal) => {
                if (item.cmpIdx === inputVal) {
                  return true
                }
                if (item.airCmp) {
                  return true
                }
                return false
              },
              filterable: true
            }
          },
          onCellValueChanged: (params) => {
            this.onRowDataChange()
          }
        }
      ]
    }
  },
  created() {
    this.rowData = []
    if (this.job.multipassAirline) {
      const airlineList = this.job.multipassAirline.split(',').map(Number)
      for (let i = 0; i < airlineList.length; i++) {
        const airline = airlineList[i]
        const airlineData = ColumnUtils.getBasicDataCacheList(TYPE_NAMES.basic_data_Company, item => item.cmpIdx === airline)
        if (airlineData) {
          this.rowData.push({
            index: i + 1,
            airlineCompany: airline
          })
        }
      }
    } else if (this.job.carrierId) {
      this.rowData = [{ index: 1, airlineCompany: this.job.carrierId }]
    }
  },
  methods: {
    addAirline() {
      const size = this.rowData.length + 1
      this.rowData.push({
        index: size
      })
    },
    onRowDataChange() {
      this.job.multipassAirline = this.rowData.reduce((accumulator, currentItem) => {
        if (currentItem.airlineCompany) {
          if (accumulator) {
            accumulator += ','
          }
          accumulator += currentItem.airlineCompany
        }
        return accumulator
      }, '')
      this.$emit('input', this.job.multipassAirline)
      this.$emit('change', this.job.multipassAirline)
    }
  }
}
</script>
